export default "__VITE_ASSET__BnhMb6mR__";